import React from 'react';
import * as asyncLoad from '../util/asyncLoad';
import { odocComsFiles } from '../constants/fileConfig';
import Loading from './Loading';

export default class OdocModelAndSensitive extends React.Component {
    constructor() {
        super();
        this.state = {
            hasLoad: false,
        };
    }
    componentWillUnmount() {
        this.timer && window.clearInterval(this.timer);
    }

    componentDidMount() {
        const init = () => {
            this.setState({ hasLoad: true});
        }
        if (!window.weaOdoc) {
            this.timer = window.setInterval(() => {
                if(window.weaOdoc) {
                    init();
                    window.clearInterval(this.timer);
                }
            }, 300);
        } else {
            init();
        }
    }
    render() {
        const { hasLoad } = this.state;
        if (hasLoad && window.weaOdoc) {
            const { commonParam, odocInfo, tabKey } = this.props;
            const { OdocModelAndSensitiveCom } = window.weaOdoc.components || {};
            const { odocModelAndSensitiveStore } = window.weaOdoc.store || {};
            return (
                <OdocModelAndSensitiveCom odocModelAndSensitiveStore={odocModelAndSensitiveStore} commonParam={commonParam} odocInfo={odocInfo} tabKey={tabKey}/>
            )
        } else {
            return (<Loading />);
        }
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/asyncComps/OdocModelAndSensitive.js